import { combineReducers } from '@reduxjs/toolkit';

import clientSelectionSlice from './slices/clientSelectionSlice';
import configSlice from './slices/configSlice';
import contentSlice from './slices/contentSlice';
import countryListSlice from './slices/countryDetailsSlice';
import currencyDetailsSlice from './slices/currencyDetailsSlice';
import customGradesSlice from './slices/customGradesSlice';
import errorSlice from './slices/errorSlice';
import filtersSlice from './slices/filtersSlice';
import jobPricingDetailsSlice from './slices/jobPricingDetailsSlice';
import jobPricingSearchSlice from './slices/jobPricingSearchSlice';
import jobSearchSlice from './slices/jobPricingSlice';
import loginSlice from './slices/loginSlice';
import navigationSlice from './slices/navigationSlice';
import peerGroupsSlice from './slices/peerGroupsSlice';
import reportsSlice from './slices/reportsSlice';
import jobPricingListSlice from './slices/SJPR/listSlice';
import userSlice from './slices/userSlice';

const rootReducer = combineReducers({
  content: contentSlice,
  clients: clientSelectionSlice,
  reports: reportsSlice,
  config: configSlice,
  filters: filtersSlice,
  error: errorSlice,
  user: userSlice,
  login: loginSlice,
  navigation: navigationSlice,
  country: countryListSlice,
  currency: currencyDetailsSlice,
  jobpricing: jobSearchSlice,
  jobPricingSearch: jobPricingSearchSlice,
  jobPricingDetails: jobPricingDetailsSlice,
  jobPricingList: jobPricingListSlice,
  peerGroups: peerGroupsSlice,
  customGrades: customGradesSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
